import getApi from '../../api'
import { CodedInformations } from '../../model/CodedInformations'

export const getCodedInformationsDetail = (id: string) =>
  getApi().get<CodedInformations>(`/coded_informations/${id}`)
